module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 85
// module chunks = 0